import React from 'react';
import { withRouter } from 'react-router-dom';

export const DaangnPath = withRouter(({ location: { pathname }, children }) => {
  // if (pathname.startsWith('/daangn')) {
  if (pathname.startsWith('/')) {
    return <>{children}</>;
  }
  return null;
});
